import * as React from "react";
import { classNames } from "@features/utils/reactFunctions";
import { ImageFile } from "react-dropzone";
import { UploadingSpinner } from "../UploadingSpinner/UploadingSpinner";

import fileIcon from "./file-icon.svg?url";
import trashIcon from "./trash.svg?url";
import * as style from "./SelectedFileStyle.module.scss"
import * as elements from "@appStyles/_elements.module.scss";

type Props = {
  file: ImageFile;
  isLoading: boolean;
  index: number;
  removeSelectedFile: (index: number) => void;
};

const fileExtension = (filename: string) => filename.split(".").pop();

export const SelectedFile = ({
  file,
  removeSelectedFile,
  index,
  isLoading,
}: Props) => (
  <div className={style.selectedFile}>
    <div
      className={classNames(
        style.selectedFileNameSection,
        isLoading ? style.selectedFileNameSectionGrayscale : ""
      )}
    >
      <div className={style.selectedFileIcon}>
        <img width="30" height="30" src={fileIcon} />
        <span>{fileExtension(file.name)?.toLocaleUpperCase()}</span>
      </div>
      <span></span>
      {file.name}
    </div>
    {isLoading && <UploadingSpinner />}
    {!isLoading && (
      <button
        className={classNames(
          elements.btn,
          elements.btnTransparent,
          elements.btnNoPadding
        )}
        onClick={() => removeSelectedFile(index)}
      >
        <img width="30" height="30" src={trashIcon} />
      </button>
    )}
  </div>
);
